export default __webpack_public_path__ + "static/media/2000.836105d2.jpg";